import { supabase } from '../lib/supabase';

export const emailService = {
  /**
   * Sends a registration success email to the user
   * @param {Object} params - Email parameters
   * @param {string} params.email - Recipient email address
   * @param {string} params.fullName - User's full name
   * @param {string} params.companyName - Company name (optional)
   * @param {string} params.applicationId - Application/submission ID (optional)
   * @returns {Promise<Object>} Email send result
   */
  async sendRegistrationEmail({ email, fullName, companyName, applicationId }) {
    try {
      if (!email || !fullName) {
        throw new Error('Email and full name are required');
      }

      // Call the Supabase Edge Function
      const { data, error } = await supabase?.functions?.invoke('send-registration-email', {
        body: {
          email,
          fullName,
          companyName,
          applicationId,
        },
      });

      if (error) {
        console.error('Edge function error:', error);
        throw new Error(`Failed to send registration email: ${error?.message}`);
      }

      if (!data?.success) {
        throw new Error(data?.error || 'Failed to send registration email');
      }

      console.log('Registration email sent successfully:', data);
      return {
        success: true,
        emailId: data?.emailId,
      };
    } catch (error) {
      console.error('Error in sendRegistrationEmail:', error);
      throw error;
    }
  },
};